// extracted by mini-css-extract-plugin
export default {"wrapper":"Topics_wrapper__sk0po","topics":"Topics_topics__eadRe","rightLayout":"Topics_rightLayout__pquYG"};